export const LINK_TYPES = { biological: "biologique", adoptive: "adoptif", legal: "légal" };
export const UNION_TYPES = { customary: "Mariage coutumier", civil: "Mariage civil", religious: "Mariage religieux", free: "Union libre", unknown: "Type inconnu" };
export const UNION_STATUSES = { ongoing: "En cours", dissolved: "Dissoute", widowhood: "Veuvage", unknown: "Statut inconnu" };
